import React, {useContext, useEffect} from 'react'
import './forex.css';
import {FaCcVisa} from 'react-icons/fa';
import {AiOutlineArrowRight} from 'react-icons/ai';
import {
    PiCurrencyDollarBold,
    PiCurrencyEurFill
} from 'react-icons/pi'
import { NavigatorContext } from '../../contexts/NavigatorContext';

export default function Forex() {
    const {setParam} = useContext(NavigatorContext);
    useEffect(()=>{
        setParam('forex');
    }, [])
  return (
    <div className='forexCard'>
        <div className='forexHeading'>
            <h2>Get Forex Card & Currency At Your Doorstep</h2>
            <h3>We offer <span style={{fontWeight:'700', color:'green'}}>same-day delivery</span> in 125+ Indian cities</h3>
        </div>
        <div className='forex-flex'>
            <div className='forex-item'>
                <div className='background-item'>{<FaCcVisa style={{fontSize:'50px',color:'blue'}}/>}</div>
                <div>
                   <h2>Multicurrency Card <AiOutlineArrowRight style={{color:'blue'}}/></h2>
                    <div>
                        Multicurrency Card Zero forex mark-upAccepted in 150+ countriesUp to 5% more savings over Credit/Debit CardsOffers & cashback
                    </div> 
                </div>
            </div>
            <div className='forex-item'>
                <div className='background-item'>{<PiCurrencyDollarBold style={{fontSize:'100px', color:'gold'}} />}{<PiCurrencyEurFill style={{fontSize:'100px',color:'gold'}} />}</div>
                <div>
                   <h2>Foreign Currency Notes <AiOutlineArrowRight style={{color:'blue'}}/></h2>
                    <div>
                        Best rates40+ currencies available Genuine notes100+ RBI-licensed money changersOffers & cashback
                    </div> 
                </div>
            </div>
        </div>
    </div>
  )
}
